export * from "./visually-hidden";
export { default } from "./visually-hidden";
//# sourceMappingURL=index.js.map